import React from 'react';
import TeamPagination from '../../../TeamManager/components/TeamPagination';
import {
  Button, CellText, DotsVertical, EmptyState, Menu, Table,
} from '@opendate-app/setlist';
import CrmDropdown from '../../../shared/components/CrmDropdown';

export default function TransactionsTab({
  team,
  transactions,
  loading,
  error,
  count,
  lastDate,
  range,
  setRange,
  page,
  setPage,
  perPage,
  totalEntries,
  totalPages,
}) {
  const eventHrefFor = (tx) => `/teams/${team.id}/confirms/${tx.id}`;

  return (
    <div className="cdp-events-tab py-4">
      {/* Summary stats row */}
      <div className="row g-4 mb-4">
        <div className="col-md-2 col-sm-6">
          <h6 className="cdp-field-label">Events with Orders</h6>
          <div className="cdp-field-value">
            {count != null ? count : '—'}
          </div>
        </div>
        <div className="col-md-2 col-sm-6">
          <h6 className="cdp-field-label">Last Order</h6>
          <div className="cdp-field-value">
            {lastDate || '—'}
          </div>
        </div>
      </div>

      {/* Transactions table card */}
      <div className="card">
        <div className="card-body p-0">
          <div className="border-bottom px-4 py-3 d-flex justify-content-between align-items-center">
            <h2 className="h6 mb-0">Transactions</h2>
            <div className="d-flex align-items-center gap-2" style={{ maxWidth: 200 }}>
              <CrmDropdown
                value={range}
                onChange={setRange}
                options={[
                  { value: '3_months', label: 'Last 3 Months' },
                  { value: '6_months', label: 'Last 6 Months' },
                  { value: '12_months', label: 'Last 12 Months' },
                  { value: 'all_time', label: 'All Time' },
                ]}
                placeholder="Date range"
                ariaLabel="Filter transactions by date range"
                minWidth={180}
                menuAlign="right"
              />
            </div>
          </div>

          <Table
            columns={[
              {
                key: 'event',
                header: 'Event',
                primary: true,
                render: (tx) => (
                  <div className="d-flex align-items-center">
                    <div
                      className="rounded overflow-hidden flex-shrink-0"
                      style={{
                        width: 48,
                        height: 48,
                        marginRight: 12,
                        backgroundColor: tx.image_url ? 'transparent' : 'var(--sl-bg-tertiary)',
                        backgroundImage: tx.image_url
                          ? `url(${tx.image_url})`
                          : 'none',
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat',
                      }}
                    />
                    <CellText
                      primary={(
                        <Button as="a" href={eventHrefFor(tx)} variant="link-color">
                          {tx.title}
                        </Button>
                      )}
                      supporting={tx.time}
                    />
                  </div>
                ),
              },
              { key: 'date', header: 'Event Date', render: (tx) => <span className="text-nowrap">{tx.date}</span> },
              { key: 'tickets_sold', header: 'Tickets Purchased', render: (tx) => tx.tickets_sold },
              { key: 'ticket_price', header: 'Total Amount', render: (tx) => tx.ticket_price },
              {
                key: 'orders',
                header: 'Orders',
                render: (tx) => (
                  <div className="d-flex flex-wrap align-items-center">
                    {(tx.orders || []).map((order, index) => (
                      <React.Fragment key={order.id}>
                        {index > 0 && <span className="text-muted mx-1">·</span>}
                        <Button
                          as="a"
                          href={`/teams/${team.id}/orders/${order.id}`}
                          variant="link-color"
                          title={order.date}
                          aria-label={`View order ${order.id} for ${tx.title}`}
                        >
                          {`#${order.id}`}
                        </Button>
                      </React.Fragment>
                    ))}
                  </div>
                ),
              },
              { key: 'presenter', header: 'Venue', render: (tx) => tx.presenter || '--' },
              {
                key: 'actions',
                header: '',
                align: 'right',
                width: '48px',
                render: (tx) => (
                  <Menu
                    placement="bottom-end"
                    trigger={(
                      <Button
                        variant="tertiary"
                        size="sm"
                        icon={DotsVertical}
                        aria-label={`More actions for ${tx.title}`}
                      />
                    )}
                    items={[
                      { label: 'Event Details', onClick: () => { window.location.href = eventHrefFor(tx); } },
                    ]}
                  />
                ),
              },
            ]}
            data={transactions}
            getRowKey={(tx) => tx.id}
            loading={loading}
            loadingLabel="Loading transactions..."
            error={error || null}
            empty={(
              <EmptyState
                size="sm"
                title={count && count > 0 ? 'No Transactions in Time Range' : 'No transactions yet.'}
              />
            )}
          />

          <TeamPagination
            currentPage={page}
            totalPages={totalPages}
            totalItems={totalEntries}
            pageSize={perPage}
            itemLabel="transactions"
            onPageChange={(newPage) => {
              if (!loading && newPage >= 1 && newPage <= totalPages) {
                setPage(newPage);
              }
            }}
          />
        </div>
      </div>
    </div>
  );
}
